import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { OpenPopinOriginator } from '@common/enum/open-popin-originator.enum';
import { CreateCaseComponent } from '@customer/itsm/request/request-create/create-case/create-case.component';
import { CreateServiceComponent } from '@customer/itsm/request/request-create/create-service/create-service.component';
import { PopinModalService } from '@ui/misc/popin-modal/popin-modal.service';

@Component({
	selector: 'aa-header-hotline-dialog',
	standalone: false,
	templateUrl: './header-hotline-dialog.component.html',
	styleUrl: './header-hotline-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	encapsulation: ViewEncapsulation.None
})
export class HeaderHotlineDialogComponent {

	constructor(
		private dialogRef: MatDialogRef<HeaderHotlineDialogComponent>,
		private popinModalService: PopinModalService
	)
	{ }
 
	close ()
	{
		this.dialogRef.close();
	}

	openIncident ()
	{
		this.popinModalService.create(CreateCaseComponent, { width: 52 }, { openPopinOriginator : OpenPopinOriginator.NO_ROUTE });
		this.close();
	}	

	openService ()
	{
		this.popinModalService.create(CreateServiceComponent, { width: 52 }, { openPopinOriginator : OpenPopinOriginator.NO_ROUTE });
		this.close();
	}
}
